<style lang="less">
	@import "../assets/css/protocol.less";
</style>
<template>
	<div class="protocol">
		<div class="w1100 box">
			<article>
				<h2 class="title">北京慧阅隐私政策</h2>
				<p><span></span>本政策仅适用于北京慧阅信息服务有限公司（以下简称“北京慧阅”）的所有产品或服务，包括“社保网络认证”、“公证IDC”、“慧阅IDC”、“慧阅网络认证”、“慧采通”、“社保卡业务在线办理”、“慧心”、“慧学”等产品。 最近更新日期：2020年3月。</p>
				<p><span></span>本政策将帮助您了解以下内容：</p>
				<p><span></span>1.我们如何收集和使用您的个人信息</p>
				<p><span></span>2.我们如何共享、转让、公开披露您的个人信息</p>
				<p><span></span>3.我们如何保护您的个人信息 </p>
				<p><span></span>4.您的权利</p>
				<p><span></span>5.我们如何处理儿童的个人信息 </p>
				<p><span></span>6.您的个人信息如何在全球范围转移</p>
				<p><span></span>7.本政策如何更新</p>
				<p><span></span>8.如何联系我们</p>
				<p><span></span>北京慧阅深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，北京慧阅承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信 息。请在使用我们的产品（或服务）前，仔细阅读并了解本《隐私政策》。</p>
				<h4 class="title">一、我们如何收集和使用您的个人信息</h4>
				<p><span></span>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。北京慧阅仅会出于本政策所述的以下目的，收集和使用您的个人信息：</p>
				<p><span></span>1.1为您提供身份认证及信息采集服务</p>
				<p><span></span>1.1.1业务功能一：身份认证；</p>
				<p><span></span>当您要领取某个机构的某项待遇、津贴、补贴时，该机构需要核验您的真实身份，且符合领取资格后才能为您发放此项费用。为此需要您提供以下信息：您的姓名、身份证号、证件照片、实拍人像照片、所属行政区划等；</p>
				<p><span></span>您提供的上述信息，将在您使用本服务期间持续授权我们使用。当您不再领取该项待遇、津贴、补贴，该机构不再使用北京慧阅的产品和服务，该机构或者您明确要求北京慧阅删除时，我们将停止使用并删除上述信息。</p>
				<p><span></span>上述信息将存储于中华人民共和国境内。如需跨境传输，我们将会单独征得您的授权同意。</p>
				<p><span></span>1.1.2业务功能二：信息采集；</p>
				<p><span></span>当您要向某机构申请具备某项业务资格或允许时，需要向该机构提交您的各项资料，并得到该申请的审核结果。为此需要您提供以下信息：姓名、身份证号（其他证件号）、电话号码、银行卡号、联系地址、电子邮件、证件照片、证件头像照片、本人头像照片、指纹图片、设备指纹等；</p>
				<p><span></span>您提供的上述信息，将在您使用本服务期间持续授权我们使用。当您不再具备某项资格或者该机构不再使用北京慧阅的产品和服务时，我们将停止使用并删除上述信息。</p>
				<p><span></span>上述信息将存储于中华人民共和国境内。如需跨境传输，我们将会单独征得您的授权同意。</p>
				<p><span></span>1.1.3业务功能三：视频采集；</p>
				<p><span></span>当您填写某些问卷或观看某些视频时，为了业务或者科学研究的需要，需要录制您的脸部的视频，进行身份验证或者表情分析；</p>
				<p><span></span>您提供的上述信息，将在您使用本服务期间持续授权我们使用。当您不再具备某项资格或者该机构不再使用北京慧阅的产品和服务时，我们将停止使用并删除上述信息。</p>
				<p><span></span>上述信息将存储于中华人民共和国境内。如需跨境传输，我们将会单独征得您的授权同意。</p>
				<p><span></span>1.1.4业务功能四：没有违法犯罪记录核实；</p>
				<p><span></span>当您向某机构申请开具自己没有违法犯罪记录的证明时，需要向该机构提交您的各项相关资料，该机构会向相关部门及渠道核实这部分信息，并得到核实结果。为此需要您提供以下信息：姓名、身份证号（其他证件号）、没有违法犯罪记录的证明等；</p>
				<p><span></span>您提供的上述信息，将在您使用本服务期间持续授权我们使用。当您不再具备某项资格或者该机构不再使用北京慧阅的产品和服务时，我们将停止使用并删除上述信息。</p>
				<p><span></span>上述信息将存储于中华人民共和国境内。如需跨境传输，我们将会单独征得您的授权同意。</p>
				<p><span></span>1.2开展审计、数据分析和研究，改善我们的产品或服务</p>
				<p><span></span>1.2.1业务审计</p>
				<p><span></span>北京慧阅为某机构提供身份认证及信息采集的产品和服务，包括为机构及其上级管理机构提供数据的查询、统计、分析等服务，以方便该机构进行业务分析，其上级管理机构进行审计时使用。</p>
				<p><span></span>1.2.2数据分析和研究以改善产品和服务</p>
				<p><span></span>北京慧阅为了改善、提高身份认证及信息采集的产品和服务，会使用您的证件照片、证件头像照片、本人头像照片等信息对人脸识别引擎进行训练，以实现人脸识别引擎的优化。</p>
				<p><span></span>当我们要将信息用于本政策未载明的其它用途时，会事先征求您的同意。</p>
				<p><span></span>当我们要将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。</p>
				<h4 class="title">二、我们如何共享、转让、公开披露您的个人信息 </h4>
				<p><span></span>2.1共享 </p>
				<p><span></span>我们不会与您申请认证及提交申请的机构以外的任何公司、组织和个人分享您的个人信息， 但以下情况除外： </p>
				<p><span></span>1.在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</p>
				<p><span></span>2.我们可能会根据法律法规规定，或按政府主管部门的强制性要求， 对外共享您的个人信息。</p>
				<p><span></span>3.与合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。例如，您的姓名、身份证号信息的核验只有权威数据源才能完成，我们必须将您的这些信息发送到权威数据源进行核验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。</p>
				<p><span></span>目前，我们的合作伙伴包括供应商、服务提供商和其他合作伙伴。我们将信息发送给中国范围内支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、分析我们服务的使用方式和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。</p>
				<p><span></span>对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。</p>
				<p><span></span>2.2转让 </p>
				<p><span></span>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
				<p><span></span>1.在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</p>
				<p><span></span>2.在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</p>
				<p><span></span>2.3公开披露</p>
				<p><span></span>我们仅会在以下情况下，公开披露您的个人信息：</p>
				<p><span></span>1.获得您明确同意后；</p>
				<p><span></span>2.基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。 </p>
				<h4 class="title">三、我们如何保护您的个人信息</h4>
				<p><span></span>3.1我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如，我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；</p>
				<p><span></span>3.2我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</p>
				<p><span></span>3.3互联网并非绝对安全的环境，而且电子邮件、即时通讯、及与其他用户的交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息。</p>
				<p><span></span>3.4互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</p>
				<p><span></span>3.5在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。</p>
				<p><span></span>同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>
				<h4 class="title">四、您的权利</h4>
				<p><span></span>按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：</p>
				<p><span></span>4.1访问您的个人信息</p>
				<p><span></span>您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：启动软件，输入您的身份信息查询您的身份认证及信息采集结果等；</p>
				<p><span></span>如果您无法通过上述方式访问这些个人信息，您可以随时发送电子邮件至service@huiyuenet.com。我们将在30天内回复您的访问请求。</p>
				<p><span></span>对于您在使用我们的产品或服务过程中产生的其他个人信息，只要我们不需要过多投入，我们会向您提供。如您想行使数据访问权，请发送电子邮件至service@huiyuenet.com。</p>
				<p><span></span>4.2更正您的个人信息 </p>
				<p><span></span>当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以发送电子邮件至service@huiyuenet.com。我们将在30天内回复您的更正请求。</p>
				<p><span></span>4.3删除您的个人信息</p>
				<p><span></span>在以下情形中，您可以向我们提出删除个人信息的请求：</p>
				<p><span></span>1.如果我们处理个人信息的行为违反法律法规； </p>
				<p><span></span>2.如果我们收集、使用您的个人信息，却未征得您的同意；</p>
				<p><span></span>3.如果我们处理个人信息的行为违反了与您的约定；</p>
				<p><span></span>4.如果我们不再为您申请认证及提交申请的机构提供产品或服务。</p>
				<p><span></span>若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。</p>
				<p><span></span>当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。</p>
				<p><span></span>4.4改变您授权同意的范围</p>
				<p><span></span>每个业务功能需要一些基本的个人信息才能得以完成（见本政策“第一部分”）。对于额外收集的个人信息的收集和使用，您可以随时给予或收回您的授权同意。您可以通过以下方式：送电子邮件至service@huiyuenet.com。</p>
				<p><span></span>当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</p>
				<p><span></span>4.5个人信息主体获取个人信息副本</p>
				<p><span></span>您有权获取您的个人信息副本，您可以通过以下方式自行操作：</p>
				<p><span></span>在技术可行的前提下，例如数据接口匹配，我们还可按您的要求，直接将您的个人信息副本传输给您指定的第三方。</p>
				<p><span></span>4.6约束信息系统自动决策</p>
				<p><span></span>在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将提供适当的救济方式。</p>
				<p><span></span>4.7响应您的上述请求</p>
				<p><span></span>为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。我们将在30天内做出答复。如您不满意，还可以通过以下途径投诉：送电子邮件至service@huiyuenet.com。</p>
				<p><span></span>对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</p>
				<p><span></span>在以下情形中，我们将无法响应您的请求：</p>
				<p><span></span>1.与个人信息控制者履行法律法规规定的义务相关的；</p>
				<p><span></span>2.与国家安全、国防安全直接相关的；</p>
				<p><span></span>3.与公共安全、公共卫生、重大公共利益直接相关的；</p>
				<p><span></span>4.与犯罪侦查、起诉、审判和执行判决等直接相关的；</p>
				<p><span></span>5.个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的；</p>
				<p><span></span>6.出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
				<p><span></span>7.响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；</p>
				<p><span></span>8.涉及商业秘密的。</p>
				<h4 class="title">五、我们如何处理儿童的个人信息 </h4>
				<p><span></span>我们的产品和服务用户包括成年人和未成年人；</p>
				<p><span></span>对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。</p>
				<p><span></span>尽管当地法律和习俗对儿童的定义不同，但我们将不满 14 周岁的任何人均视为儿童。</p>
				<p><span></span>如果我们发现自己在未事先获得可证实的父母同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。</p>
				<h4 class="title">六、您的个人信息如何在全球范围转移 </h4>
				<p><span></span>原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。</p>
				<h4 class="title">七、本政策如何更新</h4>
				<p><span></span>我们的隐私政策可能变更。 </p>
				<p><span></span>未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。</p>
				<p><span></span>我们会在本页面上发布对本政策所做的任何变更。对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，我们会通过电子邮件发送通知，说明隐私政策的具体变更内容）。</p>
				<p><span></span>本政策所指的重大变更包括但不限于：</p>
				<p><span></span>1.我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</p>
				<p><span></span>2.我们在所有权结构、组织架构等方面发生重大变化。如业务调整、 破产并购等引起的所有者变更等；</p>
				<p><span></span>3.个人信息共享、转让或公开披露的主要对象发生变化；</p>
				<p><span></span>4.您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
				<p><span></span>5.我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</p>
				<p><span></span>6.个人信息安全影响评估报告表明存在高风险时。 </p>
				<p><span></span>我们还会将本政策的旧版本存档，供您查阅。</p>
				<h4 class="title">八、如何联系我们</h4>
				<p><span></span>如果您对本隐私政策有任何疑问、意见或建议，可通过以下方式与我们联系：</p>
				<p><span></span>北京市朝阳区双营路11好美立方4号楼2单元1206室</p>
				<p><span></span>service@huiyuenet.com</p>
				<p><span></span>收到反馈后，我们将在30天内回复。</p>
			</article>
		</div>
	</div>
</template>

<script>
	export default {
		name:'protocol',
		data() {
			return {

			};
		},
		created(){
			this.url=this.$route.path;
		},
		computed: {

		},
		methods:{

		}
	}
</script>



// WEBPACK FOOTER //
// src/components/protocol.vue